module.exports = __webpack_public_path__ + "static/img/p-7.f1d4b4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-7.png
// module id = 7JZR
// module chunks = 0